import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import {
	getCounselFeeHover,
	TitleInsurancePillData,
} from '@core/util/title-insurance';
import { DirectionOfFeeType } from '@models/businessSettings/directionOfFees';
import { MatterManualTitleInsurance } from '@models/title-insurance';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ViewSelectSnapshot, SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable, combineLatest } from 'rxjs';
import { TestHooks } from './counsel-credit.hooks';

@UntilDestroy()
@Component({
	selector: 'app-counsel-credit',
	templateUrl: './counsel-credit.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CounselCreditComponent implements OnInit {
	testHooks = TestHooks;
	public counselPillData: TitleInsurancePillData;
	public premium: number;
	public displayPill = 'none';
	public ICON = ICON;

	@Input() labelPosition: 'top' | 'left' = 'top';

	@ViewSelectSnapshot(SelectedMatter.titleInsuranceCounselCredit)
	counselCredit: number;
	@Select(SelectedMatter.getTitleInsurance)
	titleInsurance$: Observable<MatterManualTitleInsurance>;
	@Select(SelectedMatter.getTitleInsuranceDirectionOfAmount)
	titleInsuranceDOA$: Observable<DirectionOfFeeType>;
	@Select(SelectedMatter.titleInsurancePremium) premium$: Observable<number>;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(private matterDispatch: MatterDispatch) {}

	ngOnInit(): void {
		combineLatest([
			this.titleInsurance$,
			this.titleInsuranceDOA$,
			this.premium$,
		])
			.pipe(untilDestroyed(this))
			.subscribe(([titleInsurance, titleInsuranceDOA, counselCredit]) => {
				this.counselPillData = getCounselFeeHover(
					titleInsurance,
					titleInsuranceDOA,
				);
				this.premium = counselCredit;
			});
	}

	setCounselCredit(value: number): void {
		const premiumInclCredits = (this.premium ?? 0) - (value ?? 0);
		this.matterDispatch.SetTitleInsurance(this.matterId, {
			extendCreditAmount: value ?? 0,
			premiumWithCounselCreditApplied: premiumInclCredits ?? 0,
		});
	}

	togglePill(_displayPill: string): void {
		this.displayPill =
			this.displayPill === _displayPill && this.displayPill !== 'none'
				? 'none'
				: _displayPill;
	}
}
